import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const LangCtx = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("velora_lang") || "es");
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("velora_cart") || "[]"); }
    catch { return []; }
  });
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => { localStorage.setItem("velora_lang", lang); }, [lang]);
  useEffect(() => { localStorage.setItem("velora_cart", JSON.stringify(cart)); }, [cart]);

  const addToCart = useCallback((product) => {
    setCart((prev) => {
      const found = prev.find((p) => p.id === product.id);
      if (found) return prev.map((p) => p.id === product.id ? { ...p, qty: p.qty + 1 } : p);
      return [...prev, { id: product.id, name_en: product.name_en, name_es: product.name_es, price: product.price, hex: product.hex, qty: 1 }];
    });
    setCartOpen(true);
  }, []);
  const updateQty = useCallback((id, qty) => setCart((prev) => prev.map((p) => p.id === id ? { ...p, qty: Math.max(1, Math.min(99, qty)) } : p)), []);
  const removeItem = useCallback((id) => setCart((prev) => prev.filter((p) => p.id !== id)), []);
  const clearCart = useCallback(() => setCart([]), []);

  const cartCount = useMemo(() => cart.reduce((s, i) => s + i.qty, 0), [cart]);
  const subtotal = useMemo(() => cart.reduce((s, i) => s + i.qty * i.price, 0), [cart]);

  // Memoize provider values so consumers don't re-render on unrelated parent renders.
  const langValue = useMemo(() => ({ lang, setLang }), [lang]);
  const cartValue = useMemo(
    () => ({ cart, addToCart, updateQty, removeItem, clearCart, cartCount, subtotal, cartOpen, setCartOpen }),
    [cart, addToCart, updateQty, removeItem, clearCart, cartCount, subtotal, cartOpen],
  );

  return (
    <LangCtx.Provider value={langValue}>
      <CartCtx.Provider value={cartValue}>
        {children}
      </CartCtx.Provider>
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
export const useCart = () => useContext(CartCtx);
